// Prisiminimai — geo-žymėtos nuotraukos (localStorage įrašai + IndexedDB nuotraukos).
// Kiekvienas prisiminimas = atskiras įrašas su koordinatėmis, kur fotkinta.
// Vienai vietai gali būti kelios nuotraukos; gali būti ir „laisvų" (be vietos).
//
// LAIKINA: lokalu, be paskyros/sinchronizacijos. Vėliau — Supabase Storage.

import {
  issaugotiPrisiminimoNuotrauka,
  istrintiPrisiminimoNuotrauka,
} from './nuotrauku_saugykla'

const RAKTAS = 'prisiminimai'

function naujasId() {
  return 'pr_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7)
}

export function getPrisiminimai() {
  try {
    const r = localStorage.getItem(RAKTAS)
    const l = r ? JSON.parse(r) : []
    return l.sort((a, b) => b.data - a.data)
  } catch {
    return []
  }
}

// Prideda prisiminimą. dataUrl — suspausta nuotrauka (į IndexedDB).
// { vietaId?, pavadinimas, lat, lng, km? } → grąžina įrašą.
export async function pridetiPrisiminima({ vietaId = null, pavadinimas = null, lat, lng, km = null, dataUrl }) {
  const id = naujasId()
  const irasas = {
    id,
    vietaId: vietaId || null,
    pavadinimas: pavadinimas || null,
    lat: lat != null ? lat : null,
    lng: lng != null ? lng : null,
    km: km != null ? Math.round(km) : null,
    data: Date.now(),
  }
  try {
    if (dataUrl) await issaugotiPrisiminimoNuotrauka(id, dataUrl)
    const sarasas = getPrisiminimai()
    localStorage.setItem(RAKTAS, JSON.stringify([irasas, ...sarasas]))
  } catch {}
  return irasas
}

export function getPrisiminimaiVietai(vietaId) {
  return getPrisiminimai().filter(p => p.vietaId === vietaId)
}

export async function istrintiPrisiminima(id) {
  try {
    const sarasas = getPrisiminimai().filter(p => p.id !== id)
    localStorage.setItem(RAKTAS, JSON.stringify(sarasas))
    await istrintiPrisiminimoNuotrauka(id)
  } catch {}
}

// Sugrupuoja prisiminimus žemėlapio markeriui: pagal vietaId, o „laisvus" —
// pagal apvalintas koordinates (~11 m). Grąžina [{ raktas, lat, lng, pavadinimas,
// naujausias, count, elementai[] }], naujausias pirmas.
export function grupuotiPrisiminimai() {
  const visi = getPrisiminimai().filter(p => p.lat != null && p.lng != null)
  const grupes = {}
  visi.forEach(p => {
    const raktas = p.vietaId || `laisvas_${p.lat.toFixed(4)}_${p.lng.toFixed(4)}`
    if (!grupes[raktas]) grupes[raktas] = []
    grupes[raktas].push(p)
  })
  return Object.entries(grupes).map(([raktas, elementai]) => {
    elementai.sort((a, b) => b.data - a.data)
    const naujausias = elementai[0]
    return {
      raktas,
      lat: naujausias.lat,
      lng: naujausias.lng,
      pavadinimas: naujausias.pavadinimas || 'Prisiminimas',
      naujausias,
      count: elementai.length,
      elementai,
    }
  }).sort((a, b) => b.naujausias.data - a.naujausias.data)
}

// ── Santykinis laikas (lietuviškai, didžiausias vienetas, apvalinta žemyn) ──
export function santykinisLaikas(ts) {
  const s = Math.floor((Date.now() - ts) / 1000)
  const d = Math.floor(s / 86400)
  if (d <= 0) return 'šiandien'
  if (d === 1) return 'vakar'
  if (d < 7) return `prieš ${d} d.`
  const sav = Math.floor(d / 7)
  if (sav < 5) return `prieš ${sav} sav.`
  const men = Math.floor(d / 30)
  if (men < 12) return `prieš ${men} mėn.`
  const met = Math.floor(d / 365)
  return `prieš ${met} m.`
}
